<template>
  <v-layout :class="containerStyles" column>
    <v-flex v-if="title" :class="titleStyles">
      <v-subheader>{{ title }}</v-subheader>
    </v-flex>
    <v-divider v-if="title" />
    <v-flex :class="contentStyles">
      <slot />
    </v-flex>
    <v-divider />
  </v-layout>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppScrollContainer',
  props: {
    title: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    containerStyles() {
      return css`
        height: ${this.height}px;
      `
    },
    titleStyles() {
      return css`
        flex: 0 0 48px !important;
      `
    },
    contentStyles() {
      return css`
        flex: 1 !important;
        overflow-y: scroll;
      `
    },
  },
}
</script>

<style></style>
